import * as React from 'react';
import { faFileVideo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import { AssetModel } from '../../models/AssetModel';
import { SessionModel } from '../../models/SessionModel';
import { ApplicationState } from '../../store';
import { LoadingIcon } from '../Misc/Loading';

type MyProps =  { SessionState: SessionModel } ;

const VIDEO_EXTENSIONS = ['mp4', 'mov', 'avi', 'wmv', 'mkv', 'webm', 'm4v', '3gp'];

const hasVideoExtension = (value?: string): boolean => {
    if (!value) { return false; }
    const path = value.split(/[?#]/)[0];
    const ext = (path.split('.').pop() || '').toLowerCase();
    return VIDEO_EXTENSIONS.indexOf(ext) >= 0;
};

const isVideoAsset = (item: AssetModel): boolean =>
    hasVideoExtension(item.documentName) || hasVideoExtension(item.imageURL) || hasVideoExtension(item.goToURL);

const formatDate = (value: string): string => {
    const date = new Date(value);
    return isNaN(date.getTime()) ? value : date.toLocaleString();
};

const AssetsComponent: React.FunctionComponent<MyProps> = (props: MyProps) => {

    const location = useLocation();

    const [assetList, updateAssets] = useState<AssetModel[]>([]);
    const [failedImages, setFailedImages] = useState<{ [index: number]: boolean }>({});

    useEffect(() => {
        if (location.state && location.state.assets) {
            updateAssets(location.state.assets);
        }
    }, [location.state]);


    return <Container fluid={true}>
        <style>
            {`
        .document-image-div {
          display: flex;
          align-items: center;
        }

        .thumbnail {
          width: 120px;
          height: 120px;
          object-fit: cover;
          border: 1px solid #ddd;
          border-radius: 4px;
          cursor: pointer;
          transition: transform 0.2s ease;
        }

        .thumbnail:hover {
          transform: scale(1.05);
        }

        .video-thumbnail {
          width: 120px;
          height: 120px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #ddd;
          border-radius: 4px;
          background-color: #f5f5f5;
          cursor: pointer;
          transition: transform 0.2s ease;
          font-size: 48px;
          color: #555;
        }

        .video-thumbnail:hover {
          transform: scale(1.05);
        }

        .asset-details {
                    font-size: 0.5rem;
                    font-weight: bold;
          word-break: break-word;
                    text-align: center;
                    color: #36454f;
        }

        .asset-comments {
          white-space: pre-wrap;
        }
      `}
        </style>
        <LoadingIcon
            loading={false}
            title={`${props.SessionState.SelectedSM.id} - ${props.SessionState.SelectedSM.name.displayName}`}
            address={props.SessionState.SelectedSM.address}
        />

        <br />
        <Row>
            {assetList.map((item, index) => (
                <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-3">
                    <Card>
                        <CardBody className="text-center">
                            <a href={item.imageURL} target="_blank" rel="noopener noreferrer">
                                {isVideoAsset(item) || failedImages[index] ? (
                                    <div className="video-thumbnail">
                                        <FontAwesomeIcon icon={faFileVideo} />
                                    </div>
                                ) : (
                                    <img
                                        src={item.imageURL}
                                        alt={item.documentName}
                                        className="thumbnail"
                                        onError={() => setFailedImages(prev => ({ ...prev, [index]: true }))}
                                    />
                                )}
                            </a>
                            <div className="asset-details mt-2">
                                <div>{item.createdBy || 'N/A'} | {item.createdOn ? formatDate(item.createdOn) : 'N/A'}</div>
                                <div className="asset-comments">{item.mediaComments || 'N/A'}</div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            ))}
        </Row>
  
    </Container>;
}

export default connect(
    (state: ApplicationState) => ({ ...{ SessionState: state.sessionState } }))(AssetsComponent as any);
